<template>
    <div class="detail-acticle-number-list">
        <p class="title">{{v.bt}}</p>
        <template v-for="(k,i) in v.section">
            <p class="detail-acticle-text_item"  :key="i" v-html="k">
            </p>
        </template>

    </div>
</template>
<script>
// import jquery from 'jquery'

export default {
    name: 'BaseNumberList',
    props: {
        v: []
    },
    data: function() {
        return {

        }
    },
    updated: function() {

    },
    mounted() {

    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

@media screen and (min-width: 801px) {
    .detail-acticle-number-list {
        max-width: 1200px;
        margin: 0 auto 30px;
    }

    .detail-acticle-text-title_line {
        position: absolute;
        left: 0;
        bottom: 0;
        background: #333;
        width: 240px;
        height: 2px;
    }

    .title {
        text-indent: 2em;
        font-size: 20px;
        line-height: 1.5em;
        font-weight: bold;
        color: #333;       
    }
    .detail-acticle-text_item {
        text-indent: 2em;
        font-size: 20px;
        line-height: 1.5em;
        color: #666;
    }
}

@media screen and (max-width: 800px) {
    .detail-acticle-number-list {
        margin: 0 auto .533rem;
    }

    .detail-acticle-text-title_line {
        position: absolute;
        left: 0;
        bottom: 0;
        background: #333;
        width: 1.7rem;
        height: 2px;
    }
    .title{
        text-indent: 2em;
        font-size: .32rem;
        line-height: 1.5em;
        font-weight: bold;
        color: #333;
    }
    .detail-acticle-text_item {
        text-indent: 2em;
        font-size: .32rem;
        line-height: 1.5em;
        color: #666;
    }
}
</style>